module.exports = __webpack_public_path__ + "fonts/CrimsonText-Bold-2.89b16aa6.ttf";